import React, { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import GavelIcon from '@mui/icons-material/Gavel';
import SupplyBillAgreeIco from '../../../supplyBill/view/items/SupplyBillAgreeIco';
import AgreeLawyerForm from './AgreeLawyerForm';
import CommentIcon from '@mui/icons-material/Comment';

const AgreeLawyerButton = ({ supplier }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <div>
            <SupplyBillAgreeIco
                classNameMain={'approval'}
                onClick={e => setOpen(true)}
                text={'Погодження юристом'}
                ico={<GavelIcon />}
                value={supplier.isAgreeLawyer}
            />

            {
                !supplier.isAgreeLawyer && supplier.isAgreeLawyer === false && supplier.disagreeLawyerText ?
                    <div className='approvalComment'>
                        <CommentIcon />
                        <p>
                            {supplier.disagreeLawyerText}
                        </p>
                    </div>
                : ''
            }
        </div>
        

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження юристом'}
            disableClickOutside={true}
            content={
                <AgreeLawyerForm
                    supplierBd={supplier}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeLawyerButton